
function InfosRecap3({ infos }) { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree

    return (
        <div className="infos-recap3">
            <div className="infos-recap3-ligne-1">
                <p className="infos-recap3-ligne-titre">Vos informations :</p>
            </div>

            <div className="infos-recap3-ligne-2">
                <p className="infos-recap3-ligne-info">{infos.prenom} {infos.nom}</p>
                <p className="infos-recap3-ligne-info">{infos.tel} - {infos.email}</p>
                <p className="infos-recap3-ligne-info">{infos.adresse}, {infos.adresse_comp}, {infos.cp}, {infos.ville}, {infos.pays}</p>

            </div>



        </div>

    )
}


export default InfosRecap3